import { render, staticRenderFns } from "./BulkShipmentViewPage.vue?vue&type=template&id=6107c0fd&scoped=true&"
import script from "./BulkShipmentViewPage.vue?vue&type=script&lang=ts&"
export * from "./BulkShipmentViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./BulkShipmentViewPage.vue?vue&type=style&index=0&id=6107c0fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6107c0fd",
  null
  
)

export default component.exports